import React from "react"

import { observer } from "mobx-react"

import { StyledAccordionList } from "./styles"
import { ListTechnicalInformationTypes } from "./types"

import { mdiChevronRight } from "@mdi/js"
import Icon from "@mdi/react"
import { styled } from "@mui/system"
import { colors } from "themes/default/tokens"
import { useTranslation } from "react-i18next"

const ListTechnicalInformation: React.FC<ListTechnicalInformationTypes> = (
  props
) => {
  const { items } = props
  const { t } = useTranslation()

  const LinkItem = styled("a")({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: `2px solid ${colors.grey2}`,
    padding: "8px 0 0 16px",
    "&:hover": {
      color: colors.secondary,
    },
  })

  return (
    <StyledAccordionList display={"block"}>
      {items.map((item) => (
        <LinkItem
          href={item.link}
          target="_blank"
          key={item.label}
          rel="noreferrer"
          sx={{
            color: "black",
            padding: "8px 0",
            textDecoration: "none",
            "&:hover": { color: "black" },
          }}
        >
          <span style={{ maxWidth: "calc(100% - 30px)" }}>{t(item.label)}</span>
          <Icon
            path={mdiChevronRight}
            size={"1.5rem"}
            style={{ marginLeft: "auto", color: "black" }}
          />
        </LinkItem>
      ))}
    </StyledAccordionList>
  )
}

export default observer(ListTechnicalInformation)
